import styled from 'styled-components'

export const StContainer = styled.div``

export const StNavigationMobile = styled.div`
  display: block;

  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Desktop}) {
    display: none;
  }
`

export const StNavigationDesktop = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Desktop}) {
    display: block;
  }
`

export const StMobileHeader = styled.div`
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};
  display: flex;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space2};
  align-items: center;
  justify-content: flex-end;

  @media (min-width: ${({ theme }) => theme.UI.BreakpointPx.Desktop}) {
    display: none;
  }
`
